import {useTranslation} from "react-i18next";
import {Form} from "react-bootstrap";

import DateDisplay from "components/datetime/DateDisplay";
import DurationDisplay from "components/datestimes/DurationDisplay";
import {REQUIRES_FIELDS} from "site-apps/distribution/route/RouteRequires";

const FormFleetRouteInfo = ({route, session, executed = [], executedTrucks = [], durationReal}) => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");

    const styleLabel = {maxWidth: "110px", display: "flex", alignItems: "center", justifyContent: "end"};
    const styleValue = {fontSize: "1.05rem", fontWeight: "400"};

    const kilosTotal = executed.reduce((s, w) => s + (w.weight || 0), 0);
    const doneCount = executed.filter((w) => w.status === "D").length;
    const totalStops = route?.checkpoints?.length ?? executed.length;
    const realEnd = session?.completed_at || session?.returned_at || session?.closed_at;
    const fmtTime = (v) => (v ? String(v).slice(0, 5) : "-");

    return (
        <div className="row mb-4 border-bottom">
            <div className="col-12">
                <table className="table table-borderless">
                    <tbody>
                        <tr>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tt("common.created")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        <DateDisplay date={route?.created_at} format="DD/MM/YYYY HH:mm" />
                                    </div>
                                </div>
                            </td>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tf("labels.assigned-truck")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        {route?.truck?.plate || "-"}
                                    </div>
                                </div>
                            </td>
                            <td
                                className="ps-3 pe-3"
                                rowSpan={4}
                                style={{verticalAlign: "top", borderLeft: "1px solid #dee2e6"}}>
                                <div className="d-flex align-items-center gap-2">
                                    <span className="small text-secondary text-nowrap">{_Tf("labels.session-status")}:</span>
                                    <span>{session?.status ? _Tc(`session_status.${session.status}`) : "-"}</span>
                                </div>
                                <div className="mt-3">
                                    <div className="small text-secondary text-nowrap">{_Tf("labels.requires")}:</div>
                                    <div className="mt-1 d-flex flex-wrap gap-3 align-items-center">
                                        {REQUIRES_FIELDS.map(({key, label}) => {
                                            const active = !!route?.requires?.[key];
                                            return (
                                                <div key={key} className="d-flex align-items-center gap-1">
                                                    <small className={active ? "" : "text-muted"}>{label}</small>
                                                    <Form.Check
                                                        type="switch"
                                                        checked={active}
                                                        disabled
                                                        readOnly
                                                        onChange={() => {}}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </td>
                            <td className="pt-0 ps-0 pb-0 pe-3 text-end">
                                <span className="text-secondary small">{_Tf("labels.kilos-total")}:</span>{" "}
                                <strong>{kilosTotal} kg</strong>
                            </td>
                        </tr>
                        <tr>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tt("containers.name")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        {route?.name}
                                    </div>
                                </div>
                            </td>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tt("users.driver")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        {session?.driver_email || "-"}
                                    </div>
                                </div>
                            </td>
                            <td className="pt-0 ps-0 pb-0 pe-3 text-end">
                                <span className="text-secondary small">{_Tf("labels.done")}:</span>{" "}
                                <strong>
                                    {doneCount} / {totalStops}
                                </strong>
                            </td>
                        </tr>
                        <tr>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tt("common.type")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        {_Tc(`route_types.${route?.type}`)}
                                    </div>
                                </div>
                            </td>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tr("labels.schedule")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        {fmtTime(route?.hour_start)} {_Tf("labels.until")} {fmtTime(route?.hour_end)} -{" "}
                                        {_Tf("labels.hours")}:{" "}
                                        <strong><DurationDisplay seconds={route?.duration} format="HH:mm" /></strong>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tf("labels.executed")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        {realEnd ? (
                                            <>
                                                <DateDisplay date={session.started_at} format="HH:mm" />{" "}
                                                {_Tf("labels.until")}{" "}
                                                <DateDisplay date={realEnd} format="HH:mm" /> - {_Tf("labels.hours")}:{" "}
                                                <strong>
                                                    {durationReal != null ? <DurationDisplay seconds={durationReal} format="HH:mm" /> : "-"}
                                                </strong>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td className="p-0">
                                <div className="row">
                                    <div className="col small text-secondary" style={styleLabel}>
                                        {_Tf("labels.telemetry-trucks")}:
                                    </div>
                                    <div className="col" style={styleValue}>
                                        {executedTrucks.length ? executedTrucks.join(", ") : "-"}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default FormFleetRouteInfo;
